
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.546 18H3.455a.84.84 0 01-.611-.268.945.945 0 01-.253-.648V8.839H0l8.919-8.6A.837.837 0 019.5 0c.215 0 .422.085.581.239L19 8.839h-2.59v8.245a.945.945 0 01-.254.648.84.84 0 01-.61.268zM4.318 16.168h10.364V7.15L9.5 2.154 4.318 7.151v9.017zm1.727-3.665h6.91v1.833h-6.91v-1.833z","fill":"#FAAD14"}})])
          )
        }
      }
    